module.exports = __webpack_public_path__ + "img/snowflake.463f6ed.svg";